import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeUp({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 48 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, onLoad = false }) {
  const trigger = onLoad
    ? { animate: "visible" }
    : { whileInView: "visible", viewport: { once: true, margin: "-40px" } };
  return (
    <span className={`block ${className}`}>
      {lines.map((l, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
          initial="hidden"
          {...trigger}
        >
          <motion.span
            className={`block ${lineClassName}`}
            variants={{ hidden: { y: "115%" }, visible: { y: "0%" } }}
            transition={{ duration: 1.2, delay: delay + i * 0.14, ease: EASE }}
          >
            {l}
          </motion.span>
        </motion.span>
      ))}
    </span>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <p className={`overline-gold flex items-center gap-4 ${className}`}>
      <span className="inline-block w-10 h-px bg-bronze" aria-hidden="true" />
      {children}
    </p>
  );
}
